
import React, { Component } from 'react';
import { auth } from '../services/firebase';
import { db } from '../services/firebase';

import { parseChatId } from '../helpers/parseChatId';

export default class EndChatBtn extends Component {
	constructor() {
		super();
        this.state = {
			user: auth().currentUser,
            error: null,
			chatId: parseChatId(),
        };
		this.endChat = this.endChat.bind(this)
	}

    async endChat() {
		// Set chat to inactive
		db.ref('chats').child(this.state.chatId).update({
			isActive: false
		});

		// Set chat-request status to completed
		db.ref('chat-requests').child("mentalhealth").child(this.state.user.uid).update({
			status: "completed"
		})
    }

    render() {
        return (
			<button type='button' onClick={this.endChat}>
				End
			</button>
		)
    }
}
